/**
 * วัดหินระฆังแห่งเขาพันบันได: the temple at dawn. The wooden fish keeps a steady beat, the great bell
 * marks the phrases, the zheng chants low and then rises; a xiao like a monk's long breath.
 */
import { drone } from '../compose';
import { registerTrack } from '../registry';

const A_ZHENG = `@mf 2,g- 3, 5, | 6,- 5, 3,/ | 2,_ 3,_ 5,_ 6,_ 1 6, | 5,- 3,\\- |
  2,- 5, 6, | 1- 6,_ 5,_ 3,~ | 5,_ 3,_ 2,_ 1,_ 2, 3, | 2,~---`;
const A_XIAO = `@p 0--- | 0--- | 0--- | 0--- | 2- 5 6 | 1'- 6_ 5_ 3 | 5_ 3_ 2_ 1_ 2 3 | 2---`;
const ROOTS_A = `2, 2, 6,, 2, 2, 5,, 6,, 2,`;

const B_ZHENG = `@f 6g. 1'_ 2' 1' | 6_ 5_ 6_ 1'_ 2'^- | 3'. 2'_ 1' 6 | 5%--- |
  6_ 1'_ 2'_ 3'_ 2' 1' | 6_ 5_ 3_ 5_ 6\\- | 5_ 3_ 2_ 3_ 5 3 | 2%---`;
const B_BASS = `@mf 2,,&6,,--- | 5,,&2,--- | 6,,&3,--- | 2,,&6,,--- | 6,,&3,--- | 5,,&2,--- | 1,&5,--- | 2,,&6,,---`;
const ROOTS_B = `2, 5,, 6,, 2, 6,, 5,, 1, 2,`;

const FISH = `k k k k`;
const temple = (drum: boolean) =>
  [`B&k k k k`, FISH, FISH, FISH, `${drum ? 'D&' : ''}k k k k`, FISH, FISH, FISH].join(' | ');

registerTrack({
  id: 'bell-stone',
  order: 7,
  title: 'ระฆังรุ่งอรุณแห่งผาหินระฆัง',
  mood: 'มั่นคง สงบนิ่ง ศรัทธา',
  use: 'วัดหินระฆังแห่งเขาพันบันได (สำนักหินระฆัง)',
  key: 'D',
  mode: 'shang',
  bpm: 72,
  meter: 4,
  seed: 707,
  parts: {
    zheng: { inst: 'zheng', pan: 0.1, reverb: 0.4 },
    bass: { inst: 'zheng', gain: 0.55, pan: -0.2, reverb: 0.35 },
    xiao: { inst: 'xiao', gain: 0.85, pan: -0.15, reverb: 0.55 },
    pad: { inst: 'pad', gain: 0.9, reverb: 0.5 },
    temple: { inst: 'perc', gain: 0.3, reverb: 0.55 },
  },
  sections: {
    A: {
      bars: 8,
      parts: { zheng: A_ZHENG, xiao: A_XIAO, pad: drone(ROOTS_A, 4), temple: temple(false) },
    },
    B: {
      bars: 8,
      parts: { zheng: B_ZHENG, bass: B_BASS, pad: drone(ROOTS_B, 4), temple: temple(true) },
    },
    A2: {
      bars: 8,
      parts: {
        zheng: A_ZHENG,
        xiao: `@mp 2- 3 5 | 6- 5 3 | 2_ 3_ 5_ 6_ 1' 6 | 5- 3- ; | 2- 5 6 | 1'- 6_ 5_ 3 | 5_ 3_ 2_ 1_ 2 3 | 2---`,
        pad: drone(ROOTS_A, 4),
        temple: temple(false),
      },
    },
  },
  form: ['A', 'B', 'A2', 'B'],
  loop: true,
});
